import { createApi } from '@reduxjs/toolkit/query/react';
import customBaseQuery from '@/lib/customBaseQuery';
import parseContentDispositionFilename from '@/utils/parseContentDispositionFilename';

export interface PatientTransferReportResult {
  blob: Blob;
  filename: string | null;
}

const reportsBaseUrl = '/api/reports';

export const reportsApi = createApi({
  reducerPath: 'reportsApi',
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    // responseHandler fires for both success and error responses; we branch on
    // response.ok so 2xx resolves with { blob, filename } while non-2xx lands in
    // err.data as { message } (matching the backend's 400 body shape). Reading
    // the body unconditionally as a blob would hide the backend's error message.
    getPatientTransferReport: builder.mutation<PatientTransferReportResult, number>({
      query: (incidentId) => ({
        url: `${reportsBaseUrl}/patient-transfer/incidents/${incidentId}`,
        method: 'GET',
        responseHandler: async (response) => {
          if (response.ok) {
            const blob = await response.blob();
            const filename = parseContentDispositionFilename(
              response.headers.get('Content-Disposition')
            );
            return { blob, filename };
          }
          try {
            return await response.json();
          } catch {
            return { message: response.statusText };
          }
        },
      }),
    }),
  }),
});

export const { useGetPatientTransferReportMutation } = reportsApi;
